import { User } from '../hooks/useUser.ts';
import { createContext } from 'react';

// Update interface to include isLoading, isError, and error from useQuery
interface AuthContextType {
  user: User | null | undefined; // Allow undefined for initial loading state from useQuery
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

// Update default value to include isLoading, isError, and error
export const AuthContext = createContext<AuthContextType>({
  user: undefined, // Default state is undefined before first fetch
  isLoading: true, // Default state is loading
  isError: false,
  error: null,
});
